module.exports = __webpack_public_path__ + "static/img/SketchPng6ab3de6c738fd4c998358d8d2587cf35a46c21dc3d71d273c258f414e1741d0d.c64a877d.png";